import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67f24b04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-ad-container" }
const _hoisted_2 = {
  key: 0,
  class: "drawer-global-menu-container"
}
const _hoisted_3 = { class: "drawer-global-menu" }
const _hoisted_4 = { style: {"flex-shrink":"0","padding-right":"10px","color":"black","font-weight":"bold"} }
const _hoisted_5 = { style: {"flex-grow":"1","display":"flex","align-items":"center","justify-content":"right"} }
const _hoisted_6 = {
  key: 0,
  style: {"margin":"0 5px"}
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "drawer-global-submenu-container" }
const _hoisted_9 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "drawer-ad-component"
}
const _hoisted_12 = {
  key: 1,
  class: "drawer-right-container"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "primary-text font-head-small",
  style: {"font-weight":"bold","flex-shrink":"0","padding":"15px 15px 15px 15px"}
}, " 便捷导航 ", -1))
const _hoisted_14 = { style: {"flex-grow":"1","display":"flex","justify-content":"space-between","flex-direction":"column"} }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { style: {"margin-left":"10px"} }
const _hoisted_17 = { class: "font-primary" }
const _hoisted_18 = {
  style: {"padding-top":"5px"},
  class: "font-assistant"
}

import {computed, onMounted, PropType, ref, watch, watchEffect} from "vue";
import {
  AppConfigComponent,
  AppConfigComponentAdItem,
  AppConfigComponentAdType,
  AppConfigComponentList
} from "@/model/AppConfig";
import {useRouter} from "vue-router";
import {parseUrl, UIHandleGet} from "@/views/utils";
import appConfigAPI from "@/api/AppConfigAPI";
import AppConfigDatasourceAPI from "@/api/AppConfigDatasourceAPI";
import {ArrowRight, DocumentDelete, EditPen, Memo, Notebook, User, VideoCamera} from "@element-plus/icons-vue";
import {tenant} from "@/store";
import {AppConfigGlobalMenu, AppConfigGlobalMenuModule} from "@/model/AppConfigGlobalMenu";



const __default__ = {
  name: "AppConfigComponentDrawerAdComponent"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  component: {
    type: Object as PropType<AppConfigComponent>,
    required: true
  }
},
  setup(__props) {

const props = __props



const width = ref<number>(0)

const adItems = computed(() => {
  if (props.component && props.component.ad) {
    return props.component.ad.items || []
  }

  return []
})

const router = useRouter()
const openLink = (item: AppConfigComponentAdItem) => {
  if (item.link) {
    window.open(parseUrl(item.link))
  }
}

const globalMenus = ref<AppConfigGlobalMenu[]>([])
const requestGlobalMenus = async () => {
  try {
    globalMenus.value = await UIHandleGet(appConfigAPI.globalMenus(AppConfigGlobalMenuModule.Resource))
  } catch (e) {
    console.error(e)
  }
}

const goResourceListView = (menuId1: string, menuId2: string) => {
  const {href} = router.resolve({
    name: 'resourceListView',
    query: {
      menuId1: menuId1,
      menuId2: menuId2
    }
  })
  window.open(href)
}

//
const getSuitableChildrenToDisplay = (menu: AppConfigGlobalMenu) => {
  let suitableItems = []
  if (menu.children) {
    let numbers = 0
    for (let child of menu.children) {
      let length = child.name?.length || 0;
      if (length + numbers <= 10) {
        numbers += length + 1
        suitableItems.push(child)
      }
    }
  }
  return suitableItems
}

const navItems = [
  {
    'name': '选课中心',
    'description': '快速便捷的查看课程',
    "path": '/resources',
    "icon": VideoCamera
  },
  {
    'name': '收藏的课程',
    'description': '查看您收藏的课程',
    "path": '/my_courses',
    "icon": Notebook
  },
  {
    'name': '练习刷题',
    'description': '海量的题目练习',
    "path": '/practice',
    "icon": EditPen
  },
  {
    'name': '个人设置',
    'description': '查看编辑个人相关信息',
    "path": '/profile',
    "icon": User
  },
  // {
  //   'name': '做题记录',
  //   'description': '快速便捷的查看您收藏的课程',
  //   "path": '/practice/history_records',
  //   "icon": Memo
  // },
]

const onClickNavItem = (item: any) => {
  const {href} = router.resolve({
    path: item.path
  })
  window.open(href)
}

onMounted(async () => {
  await requestGlobalMenus()
})


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.component.ad?.showMenuNavigation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(globalMenus.value, (menu) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(menu.name), 1),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSuitableChildrenToDisplay(menu), (child, index) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      (index > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "/"))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: "item",
                        onClick: ($event: any) => (goResourceListView(menu.id!, child.id!))
                      }, _toDisplayString(child.name), 9, _hoisted_7)
                    ]))
                  }), 256))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (menu.children)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(menu.children, (child) => {
                          return (_openBlock(), _createElementBlock("div", {
                            onClick: ($event: any) => (goResourceListView(menu.id!, child.id!)),
                            class: "drawer-global-submenu",
                            style: {"text-align":"center","margin-bottom":"20px"}
                          }, [
                            _createElementVNode("span", null, _toDisplayString(child.name), 1)
                          ], 8, _hoisted_10))
                        }), 256))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "drawer-carousel-container",
      style: _normalizeStyle({'width': __props.component.ad?.showMenuNavigation ? '718px' : '100%'})
    }, [
      (_unref(adItems).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_el_carousel, { height: "320px" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(adItems), (item) => {
                  return (_openBlock(), _createBlock(_component_el_carousel_item, {
                    onClick: ($event: any) => (openLink(item)),
                    key: item.uuid
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_image, {
                        style: _normalizeStyle([{cursor: item.link ? 'pointer' : 'default'}, {"width":"100%","height":"100%"}]),
                        fit: "fill",
                        src: item.imageUrl
                      }, null, 8, ["style", "src"])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], 4),
    (__props.component.ad?.showMenuNavigation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (x) => {
              return _createElementVNode("div", {
                onClick: ($event: any) => (onClickNavItem(x)),
                class: "nav-item"
              }, [
                _createVNode(_component_el_icon, { style: {"flex-shrink":"0","font-size":"25px","margin-right":"5px"} }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(x.icon)))
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(x.name), 1),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(x.description), 1)
                ])
              ], 8, _hoisted_15)
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})